var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"bidule-panel bidule-panel-proof-of-residence\"\u003E\u003Cdiv class=\"btn-proofofresidence text-center\" ng-click=\"openProofOfResModal()\"\u003E\u003Ca\u003E\u003Cp\u003EJUSTIFICATIF DE DOMICILE\u003C\u002Fp\u003E\u003C\u002Fa\u003E\u003Cbutton class=\"btn background-bluegrey\"\u003ETélécharger\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/states/invoice/component/invoiceBiduleProofOfResidence.jade
// module id = 925
// module chunks = 1